// src/pages/CorporateTraining.jsx
import React, { useEffect } from 'react';
import styles from './CorporateTraining.module.css';
import CoursesSection from '../components/home/CoursesSection';
import CompanyLogosSlider from '../components/includes/CompanyLogosSlider'; 

// Import the banner image from your assets folder
// Make sure this path is correct based on where you store banner.jpg
import CorporateBanner from '../assets/imgs/Bspark-Corp-Train-Banner-1.jpg'; 
import LiveTraining from '../assets/imgs/Corporate-training-inside-image-01.jpg'; 
import RecordedTraining from '../assets/imgs/Corporate-training-inside-image-02.jpg'; 
import BLENDEDTRAINING from '../assets/imgs/Corporate-training-inside-image-03.jpg'; 

// You might want to define this data in a separate file (e.g., data/corporateTrainingTypes.js)
const trainingTypes = [
  {
    id: 'live-training',
    title: 'LIVE TRAINING',
    image: LiveTraining, // Placeholder, replace with actual image
    learners: '20000+',
    rating: 5,
    mentors: '50+',
    corporates: '100+',
    description: 'Engage in real-time interactive sessions with expert instructors and peers. Perfect for dynamic learning and immediate doubt resolution.'
  },
  {
    id: 'recorded-training',
    title: 'RECORDED TRAINING',
    image: RecordedTraining, // Placeholder, replace with actual image
    learners: '5000+',
    rating: 5,
    sessions: '40+',
    corporates: '25+',
    description: 'Learn at your own pace with high-quality pre-recorded video lectures and comprehensive study materials. Access anytime, anywhere.'
  },
  {
    id: 'blended-training',
    title: 'BLENDED TRAINING',
    image: BLENDEDTRAINING, // Placeholder, replace with actual image
    learners: '10000+',
    rating: 5,
    mentors: '50+',
    corporates: '50+',
    description: 'A hybrid approach combining the flexibility of recorded content with the invaluable interaction of live sessions and personalized mentorship.'
  }
];

const CorporateTraining = ({ setIsPopupVisible }) => {
    useEffect(() => {
      document.title = "Online & Classroom Training institute in Chennai | Bspark Software Technologies";
    }, []); // The empty dependency array ensures this runs only once
  
  return (
    <div className={styles.corporateTrainingPage}>
      
      {/* Hero Section with Background and Animations */}
      <section className={styles.heroSection} 
      style={{ backgroundImage: `url(${CorporateBanner})` }}>
        <div className={styles.heroOverlay}>
          {/* Breadcrumb is placed inside hero content for visual integration */}
          {/* <div className={styles.breadcrumb}>
            <Link to="/">Home</Link> &gt; <span>Corporate Training</span>
          </div> */}
          <h1 className={styles.heroTitle}>Empower Your Team with Expert Corporate Training</h1>
          <p className={styles.heroDescription}>
            Tailored software testing programs designed to upskill your workforce, boost productivity, and drive quality.
          </p>
          <button className={styles.heroCtaButton} onClick={() => setIsPopupVisible(true)}>Request a Custom Program</button>
        </div>
      </section>

      {/* Main Training Types Section */}
      <section className={styles.trainingTypesSection}>
        <h2 className={styles.sectionHeading}>Our Flexible Training Models</h2>
        <p className={styles.sectionSubtitle}>
          Choose the format that best fits your team's needs and schedule.
        </p>

        <div className={styles.trainingCardsContainer}>
          {trainingTypes.map(type => (
            <div key={type.id} className={styles.trainingCard}>
              <div className={styles.cardImageWrapper}>
                <img src={type.image} alt={type.title} className={styles.cardImage} />
              </div>
              <h2 className={styles.cardTitle}>{type.title}</h2>
              <p className={styles.cardLearners}>{type.learners} Successful Learners</p>
              <div className={styles.cardRating}>
                {'⭐'.repeat(type.rating)} ({type.rating}/5)
              </div>
              <div className={styles.cardDetails}>
                {type.mentors && <span>{type.mentors} mentors</span>}
                {type.sessions && <span>{type.sessions} sessions</span>}
                {type.corporates && <span>{type.corporates} corporates</span>}
              </div>
              <p className={styles.cardDescription}>{type.description}</p>
              <button className={styles.cardCtaButton} onClick={() => setIsPopupVisible(true)}>Enquire Now</button>
            </div>
          ))}
        </div>
      </section>
  

      {/* Courses Section (This will display your trending testing courses) */}
      <section className={styles.featuredCoursesSection}>
        {/* The CoursesSection component itself has its own heading and subtitle */}
        <CoursesSection />
      </section>
      
      {/* Company Logos Slider Section */}
      <section className={styles.companyLogosSection}>
        {/* <h2 className={styles.sectionHeading}>Trusted by Leading Companies</h2> */}
        <CompanyLogosSlider />
      </section>

    </div>
  );
};

export default CorporateTraining;